// src/Components/NotificationPopup.js

import InfiniteScroll from "react-infinite-scroll-component";
import toast from "react-hot-toast";
import { useNotifications } from "../../Context/NotificationContext";
import { NOTIFICATION_COLORS, NOTIFICATION_TEXT } from "./constants";
import { useEffect, useState } from "react";
import { getNotification, markAllAsRead } from "../../Services/notificationServices";

const getNotificationColor = (type) => 
NOTIFICATION_COLORS[type] || NOTIFICATION_COLORS.DEFAULT;

const NotificationPopup = ({ onClose }) => {
  const [loading , setLoading] = useState(false)
  const [notifications, setNotifications] = useState([]);
  const [pagination, setPagination] = useState({
        offset: 0,
        limit: 10,
        count: 0,
      });
  const [paginationLoading, setPaginationLoading] = useState(false);
    
  const {
   unreadCount,
   setUnreadCount,
  } = useNotifications();

  const fetchNotifications = async (isInitial = false) => {
      if (!isInitial && pagination.offset >= pagination.count) return;
  
      if (isInitial) setLoading(true);
      else setPaginationLoading(true);
  
      try {
        const res = await getNotification({
          offset: isInitial ? 0 : pagination.offset,
          limit: pagination.limit,
        });
        if (res.status === 200) {
          const newNotifications = res.data.results || [];
          setNotifications((prev) =>
            isInitial ? newNotifications : [...prev, ...newNotifications]
          );
          setPagination({
            offset: (isInitial ? 0 : pagination.offset) + pagination.limit,
            limit: pagination.limit,
            count: res.data.count || 0,
          });
        } else {
          toast.error(NOTIFICATION_TEXT.FETCH_ERROR);
        }
      } catch (err) {
        toast.error(NOTIFICATION_TEXT.FETCH_ERROR);
      } finally {
        if (isInitial) setLoading(false);
        else setPaginationLoading(false);
      }
    };

    const markAll = async () => {
        if (notifications.length === 0 && unreadCount === 0) return;
        setLoading(true);
        try {
          await markAllAsRead();
          setUnreadCount(0);
          setNotifications([]);
          setPagination({
            offset: 0,
            limit: pagination.limit,
            count: 0,
          });
        } catch (err) {
          toast.error(NOTIFICATION_TEXT.FAILED_TO_MARK_READ);
        } finally {
          setLoading(false);
        }
      };
    
  

  useEffect(() => {
    fetchNotifications(true); 
  }, []);

  return (
    <>
      {/* Background overlay to close popup */}
      <div className="fixed inset-0 z-40 bg-transparent" onClick={onClose} />
      <div className="max-h-[80vh] absolute right-4 top-16 w-80 bg-white rounded-xl shadow-xl border border-gray-200 z-50 flex flex-col">
        {/* Header */}
        <div className="flex justify-between items-center p-4 font-semibold border-b text-gray-800 text-lg">
          <span>Notifications</span>
          {notifications.length > 0 && (
            <button
              onClick={markAll}
              disabled={loading}
              className="text-sm text-primary bg-white px-2 py-1 hover:text-blue-800 disabled:opacity-50"
            >
              {loading ? "Marking..." : "Mark All as Read"}
            </button>
          )}
        </div>

        {/* Scrollable list with infinite scroll */}
        <div
          className="max-h-[65vh] overflow-y-auto"
          id="notificationPopupScroll"
        >
          <InfiniteScroll
            dataLength={notifications.length}
            next={() => fetchNotifications(false)}
            hasMore={pagination.offset < pagination.count}
            loader={
              paginationLoading && (
                <p className="text-center py-2">Loading...</p>
              )
            }
            scrollableTarget="notificationPopupScroll"
          >
            {notifications.length === 0 ? (
              <div className="p-4 text-gray-500 text-sm text-center">
                {NOTIFICATION_TEXT.NO_NOTIFICATIONS}
              </div>
            ) : (
              notifications.map((n) => (
                <div
                  key={n.id}
                  className={`p-3 m-2 rounded-lg ${getNotificationColor(
                    n.message_type
                  )}`}
                >
                  <div className="font-medium text-gray-800">
                    {n.message_title}
                  </div>
                  <div className="text-xs mt-1">{n.message}</div>
                </div>
              ))
            )}
          </InfiniteScroll>
        </div>
      </div>
    </>
  );
};

export default NotificationPopup;
